import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { get, find, head } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { setSearchPattern } from "~/store/dateAndSpecialist/dateAndSpecialistActions";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { MDBSpinner } from "mdbreact";
import {
  resetSelectSubject,
  searchSubject,
  selectSubject,
  changeDirection,
  resetListNode,
  goBackStep,
  getBookingTree
} from "~/store/totalData/actions";
import { SUBJECT } from "~/utils/constants";
import { getPartnerFromUrl } from "~/utils/func";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChooseSpecialtyPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Schedules/ChooseSpecialty"),
  loading: LoadableLoading
});

class DetectChooseSpecialty extends Component {
  methods = {
    handleGoBack: () => {
      this.props.goBackStep("subject");
    }
  };

  componentDidMount() {
    const {
      subjectList,
      isDirectionBack,
      selectSubject,
      resetListNode,
      resetSelectSubject,
      getBookingTree
    } = this.props;

    if (subjectList.length === 0) {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      getBookingTree("", currentPagePartnerId);
    }

    resetListNode(SUBJECT);
    resetSelectSubject();

    if (subjectList.length === 1) {
      if (isDirectionBack) {
        this.methods.handleGoBack();
      } else {
        const subject = head(subjectList);
        selectSubject(subject);
      }
    }
  }

  componentWillUnmount() {
    this.props.setSearchPattern("");
  }

  render() {
    const { subjectList } = this.props;

    if (subjectList.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    return (
      <React.Fragment>
        <ChooseSpecialtyPageDesktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    dateAndSpecialist: { selectedSpecialist },
    hospital: { selectedHospital },
    totalData: {
      subject: {
        id: idSubject,
        list: subjectList,
        subType: subTypeSubject,
        name: subjectName
      },
      listNode,
      isDirectionBack,
      partnerId
    }
  } = state;
  return {
    device: type,
    selectedSpecialist,
    selectedHospital,
    idSubject,
    subTypeSubject,
    subjectName,
    listNode,
    subjectList,
    isDirectionBack,
    partnerId
  };
};

const DetectChooseSpecialtyHelmet = withTitle({
  component: DetectChooseSpecialty,
  title: `${hospitalName.value} | Chọn chuyên khoa`
});

export default connect(mapStateToProps, {
  setSearchPattern,
  resetSelectSubject,
  searchSubject,
  selectSubject,
  changeDirection,
  resetListNode,
  goBackStep,
  getBookingTree
})(DetectChooseSpecialtyHelmet);
